import React from 'react';

export default (props) => (
    <div className="change-password">
        <div
            className={props.validationErrors.oldPassword.status ? "text-field  has-error" : "text-field"}
        >
            <label className="text-field__label" htmlFor="current-password">Current Password</label>
            <input
                className="text-field__input"
                id="current-password"
                type="password"
                value={props.user.oldPassword}
                onChange={(e) => props.handleChange('oldPassword', e.target.value)}
                placeholder="Old password"
            />
            <span className="error-message">{props.validationErrors.oldPassword.message}</span>
        </div>
        <div
            className={props.validationErrors.password.status ? "text-field  has-error" : "text-field"}
        >
            <label className="text-field__label" htmlFor="new-password">New Password</label>
            <input
                className="text-field__input"
                id="new-password"
                type="password"
                value={props.user.newPassword}
                onChange={(e) => props.handleChange('newPassword', e.target.value)}
                placeholder="New password"
            />
            <span className="error-message">{props.validationErrors.password.message}</span>
        </div>
        <div
            className={props.validationErrors.rePassword.status ? "text-field  has-error" : "text-field"}
        >
            <label className="text-field__label" htmlFor="confirm-password">Confirm Password</label>
            <input
                className="text-field__input"
                id="confirm-password"
                type="password"
                value={props.user.rePassword}
                onChange={(e) => props.handleChange('rePassword', e.target.value)}
                placeholder="Confirm password"
            />
            <span className="error-message">{props.validationErrors.rePassword.message}</span>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/Profile/editPassword.js